import { render, staticRenderFns } from "./GeoQuestionResults.vue?vue&type=template&id=4438f143&scoped=true&"
import script from "./GeoQuestionResults.vue?vue&type=script&lang=js&"
export * from "./GeoQuestionResults.vue?vue&type=script&lang=js&"
import style0 from "./GeoQuestionResults.vue?vue&type=style&index=0&id=4438f143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438f143",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VList,VListItem,VListItemGroup,VListItemIcon,VListItemTitle,VRow,VSubheader})
